<script lang="ts" setup>
import { SensitiveInfo } from '~/utils/contents/shared/SensitiveInfo';
</script>

<template>
  <div class="flex flex-col gap-8">
    <p class="font-body text-color-secondary">
      {{ SensitiveInfo.processing }}
    </p>
    <p class="font-body text-color-secondary">
      {{ SensitiveInfo.recovery }}
    </p>
  </div>
</template>

<style lang="scss" scoped></style>
